import { createDivComponent } from '../../../_lib/createDivComponent'
import './index.css'

export const AssistiveText = createDivComponent(
  'charcoal-text-field-assistive-text',
)
